{
  "pt": {
    "levels": {
      "actions": {
        "add_customer": "Adicionar cliente",
        "cancel": "Anular",
        "changeLevel": "Alterar nível",
        "changeTargetGroup": "Alterar grupo-alvo",
        "delete": "Eliminar",
        "removeCustomer": "Separar o cliente",
        "requestUnits": "Solicitar unidades",
        "save": "Guardar"
      },
      "building": "Edifício",
      "customers": "Clientes",
      "descriptions": {
        "mupCantDelete": "Parece que ainda tem unidades dentro deste projeto. Para eliminar o projeto, recomendamos que elimine primeiro as unidades. Desta forma, temos 100% de certeza de que o projeto pode ser eliminado.",
        "mupCantDeleteDeactivate": "Uma alternativa à eliminação do projeto é a sua desativação. Desta forma, todas as informações serão preservadas para utilização futura. Pretende desativar este projeto?"
      },
      "labels": {
        "activity": "Atividade",
        "aftercare": "Pós-venda",
        "allLevels": "Todos os níveis",
        "contacts": "Contactos",
        "conversations": "Conversas",
        "decisions": "Decisões",
        "deleteProject": "Tem a certeza de que pretende eliminar {project_name}",
        "deleteProjectDisclaimer": "A eliminação deste projeto resultará na perda permanente de todos os dados e conteúdos. Esta ação é irreversível. Como alternativa, considere a possibilidade de desativar o projeto para preservar todas as informações para utilização futura. Proceda com cuidado.",
        "deleteWarning": "Cuidado! A eliminação deste nível elimina todos os níveis subjacentes, documentos, anúncios, FAQS e tarefas relacionadas com este nível.",
        "documents": "Documentos",
        "download": "Descarregar {level_name}",
        "generatingExport": "Geração de exportação",
        "hide": "Esconder",
        "information": "Informações",
        "installment": "Finanças",
        "milestones": "Marcos",
        "multiple_selection": "Multiseleção",
        "mupCantDelete": "Oh não, esta ação não é possível!",
        "needMoreUnits": "Precisa de mais unidades?",
        "reachedMax": "Criou a unidade que está atribuída a este projeto. | Alcançou as unidades {count} que estão atribuídas a este projeto.",
        "reachedMaxRundle": "Atingiu o seu limite de 1 unidade ativa. | Atingiu o seu limite de {count} unidades ativas.",
        "requestMoreUnits": "Contacte a equipa Ziggu se pretender solicitar mais unidades ativas.",
        "settings": "Definições do projeto",
        "sharedWith": "Partilhado com ",
        "showForLevel": "Mostrar {object} para o nível",
        "spaces": "Espaços",
        "surveys": "Inquéritos",
        "task_assignments": "Tarefas",
        "tickets": "Conversas",
        "todos": "Tarefas",
        "willBeAssigned": "Disponível para todos em",
        "willBePublished": "Será mostrado a todos em",
        "willBeUploaded": "Será carregado para"
      },
      "lot": "Lote",
      "phase": "Fase",
      "project": "Projeto",
      "tooltip": {
        "add_level": "Adicionar {level}"
      },
      "unit": "Unidade"
    }
  }
}
